var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"bg"},[_c('p',{staticClass:"title"},[_vm._v("亲爱的用户们：")]),_vm._v(" "),_c('p',{staticClass:"content"},[_vm._v("为了能够让您访问更快更稳定，同时为您提供更好的体验，我们正在维护系统。\n            因此目前网站的功能暂时停止使用，给您造成的不便，请谅解。 ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34298a0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/maintain.vue
// module id = null
// module chunks = 